<template>
  <section>
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <section slot="driver" slot-scope="prop">
        <ChooseDriver
          ref="chooseDriver"
          :isRadio="true"
          showName="loginAcct"
          :isInput="true"
          v-model="prop.form.driver"
          :otherSearchData="{ linkman: prop.form.driver.linkman || '' }"
          @change="handleDriverChange"
        />
      </section>
      <section slot="driverUserNameUnit">
        <span
          class="primary cur"
          style="margin-right: 10px;"
          @click="handleShowDriverDialog('chooseDriver')"
        >选择</span>
      </section>
      <section slot="copilotDriver" slot-scope="prop">
        <ChooseDriver
          ref="chooseCopilotDriver"
          :isRadio="true"
          showName="loginAcct"
          :isInput="true"
          v-model="prop.form.copilotDriver"
          :otherSearchData="{ linkman: prop.form.copilotDriver.linkman || '' }"
          @change="handleCopilotDriverChange"
        />
      </section>
      <section slot="copilotDriverNameUnit">
        <span
          class="primary cur"
          style="margin-right: 10px;"
          @click="handleShowDriverDialog('chooseCopilotDriver')"
        >选择</span>
      </section>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </section>
</template>

<script>
import ChooseDriver from 'components/choose/driver';
import {
  doQueryCarDriver,
} from 'api/car';
export default {
  components: {
    ChooseDriver,
  },
  watch: {
    '$route.query.type': {
      immediate: true,
      handler (newValue) {
        if (newValue === 'my' || newValue === 'outward') {
          this.setBaseForm(newValue);
        }
      },
    },
    masterDriver: {
      immediate: true,
      handler (newValue) {
        if (newValue.driverUserId) {
          this.$nextTick(() => {
            if (newValue.driverUserPhone) {
              this.$refs.baseForm.setVal('driver', {
                loginAcct: newValue.driverUserPhone,
                userId: newValue.driverUserId,
                linkman: newValue.driverUserName,
                carUserType: newValue.driverCarUserType,
              });
            }
            if (newValue.driverUserName) {
              this.$refs.baseForm.setVal('driverUserName', newValue.driverUserName);
            }
          });
        } else {
          this.$nextTick(() => {
            this.$refs.baseForm.setVal('driver', {});
            this.$refs.baseForm.setVal('driverUserName', '');
          });
        }
      },
    },
    copilotDriver: {
      immediate: true,
      handler (newValue) {
        if (newValue.copilotDriverId) {
          this.$nextTick(() => {
            if (newValue.copilotDriverPhone) {
              this.$refs.baseForm.setVal('copilotDriver', {
                loginAcct: newValue.copilotDriverPhone,
                userId: newValue.copilotDriverId,
                linkman: newValue.copilotDriverName,
                carUserType: newValue.copilotDriverUserType,
              });
            }
            if (newValue.copilotDriverName) {
              this.$refs.baseForm.setVal('copilotDriverName', newValue.copilotDriverName);
            }
          });
        } else {
          this.$nextTick(() => {
            this.$refs.baseForm.setVal('copilotDriver', {});
            this.$refs.baseForm.setVal('copilotDriverName', '');
          });
        }
      },
    },
  },
  props: {
    // 主驾
    masterDriver: {
      type: Object,
      default: () => ({}),
    },
    // 副驾
    copilotDriver: {
      type: Object,
      default: () => ({}),
    },
    // 车辆种类
    vehicleClass: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      showComponent: true,
      baseForm: {
        inline: true,
        form: [
          {
            label: '主驾手机号',
            value: 'driver',
            default: {},
            slot: true,
          },
          {
            label: '主驾姓名',
            value: 'driverUserName',
            type: 'el-autocomplete',
            valueKey: 'linkmanAndMobilePhone',
            querySearchAsync: this.querySearchAsync,
            onSelect: async (item) => {
              if (item) {
                this.$refs.baseForm.setVal('driverUserName', item.linkman);
                this.$refs.baseForm.setVal('driver', item);
              }
            },
          },
          {
            label: '副驾手机号',
            value: 'copilotDriver',
            default: {},
            slot: true,
            hide: false,
          },
          {
            label: '副驾姓名',
            value: 'copilotDriverName',
            type: 'el-autocomplete',
            valueKey: 'linkmanAndMobilePhone',
            querySearchAsync: this.querySearchAsync,
            onSelect: async (item) => {
              if (item) {
                this.$refs.baseForm.setVal('copilotDriverName', item.linkman);
                this.$refs.baseForm.setVal('copilotDriver', item);
              }
            },
            hide: false,
          },
        ],
        rules: {
          driverUserName: [
            { required: false, message: '请输入司机姓名', trigger: 'blur' },
          ],
          driver: [
            { required: false, message: '请输入司机手机', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    querySearchAsync (queryString, cb) {
      let resInfo = [];
      if (queryString && queryString.length) {
        doQueryCarDriver({
          linkman: queryString,
          random: Math.random(),
        }).then((res) => {
          if (res && res.items) {
            res.items.forEach((item) => {
              item.loginAcct = `${item.mobilePhone}`;
              item.linkmanAndMobilePhone = `${item.linkman}（${item.mobilePhone}）`;
            });
            const filterData = res.items.filter((item) => item.linkman.includes(queryString));
            resInfo = filterData;
          }
          cb(resInfo);
        });
      } else {
        cb(resInfo);
      }
    },
    handleDriverChange () {
      const driver = this.$refs.baseForm.getVal('driver');
      this.$refs.baseForm.setVal('driverUserName', driver.linkman);
    },
    handleCopilotDriverChange () {
      const copilotDriver = this.$refs.baseForm.getVal('copilotDriver');
      this.$refs.baseForm.setVal('copilotDriverName', copilotDriver.linkman);
    },
    handleShowDriverDialog (componentName) {
      this.$refs[componentName].show();
    },
    async handleSubData (cache) {
      let formData = null;
      // 外调车档案新增司机的表单在基础信息base文件里，而自有车档案新增司机信息的表单在该文件，当外调车新增时获取到的表单数据，
      // 会由于自有车档案的表单里driverUserId覆盖base文件的表单数据，造成外调车新增报错，此处判断类型是否是外调车，当类型是外调车时司机信息表单不传数据即可解决问题
      if (this.$route.query.type !== 'outward') {
        if (cache) {
          formData = await this.$refs.baseForm.getVal();
        } else {
          formData = await this.$refs.baseForm.sub();

        }
        if (formData || cache) {
          // bug场景：一个没有主驾信息的自有车修改为外调车时，填了司机信息但接口一直报错“请选择司机”
          // 原因：在上方注释（之前只解决了外调车档案菜单新增保存的问题，未解决自有车修改为外调车的场景问题）
          // 解决：增加判断基础信息里选择的车辆种类是否为外调车，当车辆种类是外调车时司机信息表单不传数据即可解决问题
          if (this.vehicleClass !== '3') {
            formData = {
              driverUserId: formData.driver.userId,
              driverMobilePhone: formData.driver.loginAcct,
              driverName: formData.driver.linkman,
              applyDriverUserId: formData.driver.userId,
              driverCarUserType: formData.driver.carUserType,
              copilotDriverId: formData.copilotDriver.userId,
              copilotDriverMobilePhone: formData.copilotDriver.loginAcct,
              copilotDriverUserName: formData.copilotDriver.linkman,
              copilotDriverUserType: formData.copilotDriver.carUserType,
            };
          } else {
            formData = {};
          }
        }
        return formData;
      } else {
        formData = {};
        return formData;
      }

    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
    setBaseForm (mode) {
      let fieldHide = false;
      if (mode === 'my') {
        fieldHide = false;
      } else {

        fieldHide = true;
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'label',
          value: '司机手机',
          names: ['driver'],
        });
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'label',
          value: '司机姓名',
          names: ['driverUserName'],
        });
      }
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: fieldHide,
        names: ['copilotDriver', 'copilotDriverName'],
      });
      this.baseForm.rules.driverUserName[0].required = false;
      this.baseForm.rules.driver[0].required = fieldHide;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
